import React, { useMemo } from "react";
import BoardIndex from "../board/BoardIndex";

import { getYouTubeVideoID } from "util/liveStream";
import { usePlatform } from "util/usePlatform";

import "./LiveStreamIndex.scss";

export const LiveStreamIndex = () => {
  const platform = usePlatform();
  const src = useMemo(() => {
    const id = getYouTubeVideoID(platform.liveStreamLink);
    if (!id) {
      return undefined;
    }
    return `https://www.youtube-nocookie.com/embed/${id}`;
  }, [platform.liveStreamLink]);

  return (
    <div className="live-stream-index">
      <div className="live-stream-iframe-wrapper">
        {src && (
          <iframe
            src={src}
            title="LiveStream"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        )}
      </div>
      <div>
        <BoardIndex />
      </div>
    </div>
  );
};

export default LiveStreamIndex;
